import { gql } from '@apollo/client/core';

export const VIEWER_AVAILABILITIES_QUERY = gql`
  query ($count: Int, $after: String) {
    viewer(kind: SITTER) {
      ... on Sitter {
        availabilities(first: $count, after: $after) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            node {
              start
              end
              kind
              cause {
                ... on InterviewContract {
                  id
                  interviewContractKind
                  parent {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const ACCOUNT_AVAILABILITIES_QUERY = gql`
  query ($id: UUID!, $kind: AccountKind!, $count: Int, $after: String) {
    account(id: $id, kind: $kind) {
      id
      ... on Sitter {
        availabilities(first: $count, after: $after) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          lastUpdatedAt
          edges {
            cursor
            node {
              start
              end
              kind
            }
          }
        }
      }
    }
  }
`;

export const AVAILABILITY_CHECKS = gql`
  query {
    availabilityChecks
  }
`;

export default {
  availabilities: VIEWER_AVAILABILITIES_QUERY,
  accounts: ACCOUNT_AVAILABILITIES_QUERY,
};
